export const errorAlways = globalThis.console.error;

export class ConsoleLogger {
    constructor(logger, { isEnabled = () => true } = {}) {
        return new Proxy(logger, {
            get: (target, prop) => {
                if (prop === 'errorAlways') {
                    return errorAlways;
                }
                if (isEnabled()) {
                    return target[prop]?.bind(target);
                }
                return () => {};
            }
        })
    }
}